var _g, _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDailycheckin = function SvgDailycheckin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_checkin)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7532 5.15332H7.24677C5.45648 5.15332 4 6.51204 4 8.18215V22.6478C4 24.3179 5.45648 25.6766 7.24677 25.6766H22.7532C24.5435 25.6766 26 24.3179 26 22.6478V8.18215C26 6.51208 24.5435 5.15332 22.7532 5.15332V5.15332Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7532 5.15332H7.24677C5.45648 5.15332 4 6.51204 4 8.18215V12.1406C4 12.5327 4.34075 12.8506 4.76114 12.8506H25.2389C25.6592 12.8506 26 12.5327 26 12.1406V8.18215C26 6.51208 24.5435 5.15332 22.7532 5.15332V5.15332Z",
    fill: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98571 19.088C7.26722 20.5042 5.34745 21.2333 4 21.5218V22.6478C4 24.3179 5.45648 25.6766 7.24677 25.6766H22.7532C24.5435 25.6766 26 24.3179 26 22.6478V17.7798C22.6668 16.4418 17.0101 15.4286 9.98571 19.088V19.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0351 8.727C9.61468 8.727 9.27393 8.40912 9.27393 8.01696V3.71004C9.27393 3.31788 9.61468 3 10.0351 3C10.4554 3 10.7962 3.31788 10.7962 3.71004V8.01696C10.7962 8.40912 10.4554 8.727 10.0351 8.727Z",
    fill: "#686767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9652 8.727C19.5449 8.727 19.2041 8.40912 19.2041 8.01696V3.71004C19.2041 3.31788 19.5449 3 19.9652 3C20.3856 3 20.7264 3.31788 20.7264 3.71004V8.01696C20.7264 8.40912 20.3856 8.727 19.9652 8.727Z",
    fill: "#686767"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 22,
    r: 5,
    fill: "#FF5E6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.5L20.3333 24L23 21",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_checkin",
    x: 0,
    y: 0,
    width: 30,
    height: 30.6766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDailycheckin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dailycheckin.ad0512852477f12ecabb8ba9c57c55f0.svg";